"use client"

import { useEffect, useState } from "react"
import { ref as storageRef, listAll, getDownloadURL } from "firebase/storage"
import { storage } from "../Firebase/firebase-config"
import { useGetCurrentUserId } from "../hooks/useGetCurrentUserId" // adjust path if needed
import { FaDownload,} from "react-icons/fa"
import "./Downloads.css"

const Downloads = ({ category, onClose, forcedUserId }) => {
 const { userId: hookUserId, loading: idLoading } = useGetCurrentUserId()
 const effectiveUserId = forcedUserId || hookUserId
  const [files, setFiles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

 useEffect(() => {
    const fetchFiles = async () => {
      if (!effectiveUserId || idLoading) return

      setLoading(true)
      setError("")
      setFiles([])

      try {
        const folder = category === "mtc" ? "mtc" : "user-statements"
        const storagePath = `${folder}/${effectiveUserId}`  // ← Now uses correct UID

        const listRef = storageRef(storage, storagePath)
        const listResult = await listAll(listRef)

        const filePromises = listResult.items.map(async (itemRef) => {
          const url = await getDownloadURL(itemRef)
          return { name: itemRef.name, url }
        })

        const fileList = await Promise.all(filePromises)
        setFiles(fileList.reverse())
      } catch (err) {
        console.error("Error fetching files:", err)
        setError("No files found or access denied.")
      } finally {
        setLoading(false)
      }
    }

    fetchFiles()
  }, [effectiveUserId, category, idLoading])

  const handleDownload = (url, name) => {
    const safeName = name.replace(/[<>:"/\\|?*]/g, "_")
    if (window.confirm(`Open ${safeName} in a new tab?`)) {
      window.open(url, "_blank")
    }
  }

  const title = category === "mtc" ? "MTC Files" : "My Statements"

  return (
    <>
      <div className="file-popup-overlay" onClick={onClose} />
      <div className="file-popup">
        <div className="file-popup-header">
          <h3>{title}</h3>
         
        </div>

        <div className="file-popup-content">
          {idLoading || loading ? (
            <p>Loading files...</p>
          ) : error ? (
            <p className="error">{error}</p>
          ) : files.length === 0 ? (
            <p>No files available.</p>
          ) : (
            <ul className="file-list">
              {files.map((file, idx) => (
                <li key={idx} className="file-item">
                  <span className="file-name">{file.name}</span>
                  <FaDownload
                    className="download-icon"
                    onClick={() => handleDownload(file.url, file.name)}
                  />
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="file-popup-footer">
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </>
  )
}

export default Downloads